// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetBestEnrollmentRequest {
    static getAttributeTypeMap() {
        return GetBestEnrollmentRequest.attributeTypeMap;
    }
}
GetBestEnrollmentRequest.discriminator = undefined;
GetBestEnrollmentRequest.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    }
];
//# sourceMappingURL=getBestEnrollmentRequest.js.map